import { Navigate, useLocation } from "react-router-dom";
import { usePlatformSessionStore } from "@/store/platformSession.store";

function RequirePlatformSession({ children }) {
  const operator = usePlatformSessionStore((s) => s.operator);
  const ensureSessionValid = usePlatformSessionStore((s) => s.ensureSessionValid);
  const location = useLocation();
  const valid = ensureSessionValid();
  if (!operator || !valid) {
    return (
      <Navigate
        to="/platform/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }
  return children;
}

export default RequirePlatformSession;
